<template>
			<form id="one-sun">
				<div class="field is-horizontal">
					<div class="field-label is-normal">
						<label class="label">Full Name:</label>
					</div>
					<div class="field-body">
						<div class="field">
							<p class="control is-expanded has-icons-left">
								<input class="input" type="text" :class="{'is-danger': errors.name}" @change="checkName" maxlength="100" placeholder="Name" v-model="contact.name">
								<span class="icon is-small is-left">
								<i class="fa fa-user"></i>
								</span>
								<p class="help is-danger" v-if="errors.name">{{ errors.name }}</p>
						</div>
					</div>
				</div>
				<div class="field is-horizontal">
					<div class="field-label is-normal">
						<label class="label">Email:</label>
					</div>
					<div class="field-body">
						<div class="field">
							<p class="control is-expanded has-icons-left has-icons-right">
								<input class="input" type="email" :class="{'is-danger': errors.email}" @change="checkEmail" maxlength="150" placeholder="Email" v-model="contact.email">
								<span class="icon is-small is-left">
								<i class="fa fa-envelope"></i>
								</span>
								<p class="help is-danger" v-if="errors.email">{{ errors.email }}</p>
						</div>
					</div>
				</div>
				<div class="field is-horizontal">
					<div class="field-label is-normal">
						<label class="label">Phone:</label>
					</div>
					<div class="field-body">
						<div class="field is-expanded">
							<div class="field has-addons">
								<p class="control">
									<a class="button is-static"> +1 </a>
								</p>
								<p class="control is-expanded">
									<input class="input" type="tel" :class="{'is-danger': errors.phone}" @change="checkPhone" placeholder="Your phone number" v-model="phone">
								</p>
							</div>
							<p class="help is-danger" v-if="errors.phone">{{ errors.phone }}</p>
						</div>
					</div>
				</div>
				<div class="field is-horizontal">
					<div class="field-label">
						<label class="label">Best way to contact:</label>
					</div>
					<div class="field-body">
						<div class="field is-narrow">
							<div class="control">
								<label class="checkbox">
								<input type="radio" value="E" v-model="contact.method">
								Email </label>&nbsp;&nbsp;&nbsp;<label class="checkbox">
								<input type="radio" value="P" v-model="contact.method">
								Phone </label>
							</div>
						</div>
					</div>
				</div>
				<div class="field comment">
					<label class="label">Comment (up to 200 characters)</label>
					<div class="control">
						<textarea class="textarea" :class="{'is-danger': errors.comments}" @change="checkComments" placeholder="Your text here" maxlength="200" v-model="contact.comments"></textarea>
						<p class="help is-danger" v-if="errors.comments">{{ errors.comments }}</p>
					</div>
				</div>
				<div class="field">
					<div class="control has-text-centered">
						<button class="button is-primary g-recaptcha" data-sitekey="6Leu1qMZAAAAAIdJv8c-7BXAefRF6mVGVJMSVo5f" @click.prevent="submit">
						<strong>Submit</strong>
						</button>
					</div>
				</div>
			</form>
</template>

<script>
	export default {
		props: {
			referral: Number
		},
		data() {
			return {
				errors: {
					comments: null,
					phone: null,
					email: null,
					name: null,
				},
				contact: {
					comments: "",
					phone: "",
					email: "",
					name: "",
					method: "P",
					referral: 0
				}
			}
		},
		methods: {
			checkEmail() {
				this.errors.email = null	
				if (this.contact.email.length === 0) {
					this.errors.email = "Email is required."
				} else if (this.contact.email.length > 150) {
					this.errors.email = "Email is too long"
				} else if (!/^.+@.+\..+$/.test(this.contact.email)) {
					this.errors.email = "Email is invalid"
				}
			},
			checkName() {
				this.errors.name = null
				if (this.contact.name.length === 0) {
					this.errors.name = "Name is required."
				} else if (this.contact.name.length > 100) {
					this.errors.name = "Name is too long"
				}
			},
			checkPhone() {
				this.errors.phone = null
				if (this.contact.phone.length === 0) {
					this.errors.phone = "Phone is required."
				} else if (!/^\d{10}$/.test(this.contact.phone)) {
					this.errors.phone = "Phone is not valid"
				}
			},
			checkComments() {
				this.errors.comments = null
				if (this.contact.comments.length > 200) {
					this.errors.comments = "Comments are too long"
				}
			},
			checkForm() {
				this.checkEmail()
				this.checkPhone()
				this.checkName()
				this.checkComments()

				for (const key in this.errors) {
					if (this.errors[key] !== null) { return false }
				}

				return true
			},
			async submit() {
				if (this.checkForm()) {
					await this.$root.$data.setters.createContact(this.$root.$data.state, this.contact)
					this.contact = {
						comments: "",
						phone: "",
						email: "",
						name: "",
						method: "P",
						referral: this.referral
					}
					this.$emit("saved")
				}
			},
			formatPhone() {
				const phone = this.contact.phone
				return `${phone.slice(0, 3)}${phone.length > 3 ? '-' : ''}${phone.slice(3, 6)}${phone.length > 6 ? '-' : ''}${phone.slice(6)}`
			}
		},
		computed: {
			phone: {
				get() {
					return this.formatPhone()
				},
				set(newValue) {
					this.contact.phone = newValue.replace(/-/g, '')
				}
			}
		},
		created() {
			this.contact.referral = this.referral
		}
	}
</script>